import styled from 'styled-components';

export const TitleContainer = styled.span`
  display: inline-flex;
  align-items: center;
  width: 100%;
`;

export const TitleOverflow = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
